
  <h2 class="mat-dialog-title">{{'about_us.our_vision' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <p style="text-align: justify;">{{'about_us.vision' | translate}}</p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'about_us.mission_btn' | translate}}</button>
</mat-dialog-actions>


